import { TrendingUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useGetApiCompaniesCurrentEmployeesReportingTopemployees } from '@/api/generated/company-management-user/company-management-user'
import { StatisticsCard } from '../components/StatisticsCard'

export function TopPointsCard() {
  const { t } = useTranslation('dashboard')
  // Shares the request with TopActionsCard via the same query key
  const { data, isLoading, isError } = useGetApiCompaniesCurrentEmployeesReportingTopemployees()

  const top = data?.data?.topPoints

  return (
    <StatisticsCard
      title={t('statistics.topPoints.title')}
      value={top ? top.value.toLocaleString('de-DE') : '—'}
      sub={top ? [top.firstName, top.lastName].filter(Boolean).join(' ') : undefined}
      CustomIcon={TrendingUp}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
